import { h } from '@stencil/core';

export const customOptionTemplate = (item, highlight, term?) => {
  const showHighlight = highlight && term;
  return [
    // @ts-ignore
    <div value={item.value} class="custom" style={{ color: 'green' }}>
      {showHighlight ? <span innerHTML={item.highlightedLabel}></span> : item.label}
    </div>,
    null
  ];
};
